$('#produto-1 option, #produto-2 option, #produto-3 option, #produto-4 option #produto-5 option, #produto-6 option').attr(`selected`,false)

$('#produto-1 option:first-of-type, #produto-2 option:first-of-type, #produto-3 option:first-of-type, #produto-4 option:first-of-type, #produto-5 option:first-of-type, #produto-6 option:first-of-type').attr(`selected`,true)

$('.featured-product__add-to-cart-button').attr(`disabled`,true)


//6 produtos
if( $('#produto-6').length )
{
  $('#produto-1, #produto-2, #produto-3, #produto-4, #produto-5, #produto-6').on( "change", function() {
      if( $('#produto-1').val() != null && $('#produto-2').val() != null && $('#produto-3').val() != null && $('#produto-4').val() != null && $('#produto-5').val() != null && $('#produto-6').val() != null){
        $('.featured-product__add-to-cart-button').attr(`disabled`,false)
      }
  } );
}
else{
    $('#produto-1, #produto-2, #produto-3, #produto-4').on( "change", function() {
      if( $('#produto-1').val() != null && $('#produto-2').val() != null && $('#produto-3').val() != null && $('#produto-4').val() != null){
        $('.featured-product__add-to-cart-button').attr(`disabled`,false)
      }
  } );
}